import CoursePreviewBannerContainer from './container'
export default CoursePreviewBannerContainer
